
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.607 7.522c-5.879 0-10.668 4.769-10.668 10.623v20.518c0 1.275 1.04 2.3 2.31 2.3h5.399v8.233a2.942 2.942 0 002.95 2.937c1.629 0 2.949-1.314 2.949-2.937v-8.233h5.399c1.28 0 2.31-1.035 2.31-2.3V18.145c.02-5.864-4.77-10.623-10.649-10.623zm.95 41.675c0 .517-.43.945-.95.945a.954.954 0 01-.95-.946v-8.233h1.9v8.233zm7.399-10.235H21.258a.31.31 0 01-.31-.309V19.757l10.279 5.137c.09.05.19.07.29.07a.645.645 0 00.29-1.225l-10.869-5.435v-.17c0-4.758 3.89-8.631 8.67-8.631 4.778 0 8.668 3.873 8.668 8.632v8.83l-1.99-.995a.65.65 0 00-.87.289.645.645 0 00.29.866l2.58 1.284v10.234a.33.33 0 01-.33.319z"}})])
          )
        }
      }
    